export const SUCCESS_FONT = "SUCCESS_FONT";
export const LOADING_FONT = "LOADING_FONT";
